import { atom } from 'jotai';

export const isMapViewAtom = atom(false);
